module.exports = __webpack_public_path__ + "img/login_bg.f29d3ef5.png";